






















import { Prop, Component, Mixins, Watch } from 'vue-property-decorator';
import { Option, Select } from 'element-ui';
import places from '@/mixins/placeOptions.ts';
import { TransportationTypeEnum, PlaceFields } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    'el-option': Option,
    'el-select': Select
  }
})
export default class PortSelect extends Mixins(places) {
  @Prop({ default: true, type: Boolean }) autoSelection!: boolean;
  @Prop() place!: PlaceFields;
  @Prop({ type: String }) transportType!: TransportationTypeEnum;

  private placeId: string | null = null;

  created() {
    this.autoSelect = this.autoSelection;
  }

  @Watch('place', { immediate: true })
  private setPlace(place: PlaceFields) {
    if (place && place.id) {
      this.placeId = place.id;
      this.searchPlace = place.name || '';
      this.placeOptions = [this.formatPlaceOptions(place)];
    }
  }

  @Watch('transportType', { immediate: true })
  private resetOptions(transportType: TransportationTypeEnum) {
    this.transportationType = this.transportType;
    this.placeOptions = [];
  }
}
